/**
 * App Configuration
 * Centralized configuration for API URLs and endpoints
 */

// API Base URL (from env or default to localhost)
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3002';

// API Endpoints
export const API_ENDPOINTS = {
  // Health
  health: `${API_BASE_URL}/api/health`,

  // User
  userProfile: `${API_BASE_URL}/api/user/profile`,
  userApps: `${API_BASE_URL}/api/user/apps`,

  // Super Admin
  superAdmin: `${API_BASE_URL}/api/super-admin`,
} as const;

// Helper function to build API URL
export const buildApiUrl = (path: string): string => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_BASE_URL}/${cleanPath}`;
};
